import { render, staticRenderFns } from "./FooterGreen.vue?vue&type=template&id=31f4436f&scoped=true&"
import script from "./FooterGreen.vue?vue&type=script&lang=js&"
export * from "./FooterGreen.vue?vue&type=script&lang=js&"
import style0 from "./FooterGreen.vue?vue&type=style&index=0&id=31f4436f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4436f",
  null
  
)

export default component.exports